exports["ES"] = require("./ES.js");
exports["TR"] = require("./TR.js");
exports["BE"] = require("./BE.js");
exports["RU"] = require("./RU.js");